export const DIVIDE_BY = 8;
export const WIDTH = window.screen.width;
export const HEIGHT = window.screen.height;
export const DIMENSION = window.screen.height < 350 ? 280 : 320;